import { frontendURL } from '../../../helper/URLHelper';
import Home from './Home.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/home'),
      name: 'home_blank',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Home,
    },
  ],
};
